import { render, staticRenderFns } from "./ListeAusbildungsplaene.vue?vue&type=template&id=308d448c"
import script from "./ListeAusbildungsplaene.vue?vue&type=script&lang=js"
export * from "./ListeAusbildungsplaene.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports